import React from "react";
import {Grid, GridProps, Stack, Text} from "@chakra-ui/core";

import ProductCard from "../../ProductCard";
import {Product} from "../../../types";

interface Props extends GridProps {
  isSelected: boolean;
  products: Product[];
  category: Product["category"];
  onProductClick: (product: Product) => void;
}

const Landscape: React.FC<Props> = ({category, products, onProductClick, isSelected, ...props}) => {
  const element = React.useRef<HTMLElement>();

  React.useEffect(() => {
    if (isSelected) {
      element.current?.scrollIntoView({behavior: "smooth", block: "start", inline: "start"});
    }
  }, [isSelected]);

  return (
    <Stack ref={element} spacing={{base: 0, sm: 4}}>
      <Stack
        isInline
        fontSize={{base: "lg", sm: "2xl"}}
        fontWeight={500}
        paddingX={{base: 4, sm: 0}}
        spacing={1}
        textTransform="capitalize"
      >
        <Text as="h2" data-test-id="title">
          {category}
        </Text>
        <Text color="gray.400">({products.length})</Text>
      </Stack>
      <Grid
        autoRows="auto"
        gridGap={{base: 0, sm: 8}}
        paddingY={{base: 4, sm: 0}}
        templateColumns={{
          base: "repeat(auto-fill, minmax(320px,1fr))",
          sm: "repeat(auto-fill, minmax(400px,1fr))",
        }}
        {...props}
      >
        {products.map((product) => (
          <ProductCard
            key={product.id}
            layout="landscape"
            product={product}
            onClick={() => onProductClick(product)}
          />
        ))}
      </Grid>
    </Stack>
  );
};

export default Landscape;
